// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"9e59b723","621":"b8816319","743":"d4579c27","917":"8b3dd743"}[chunkId] + ".chunk.js";
};